import { render, staticRenderFns } from "./EmailSender.vue?vue&type=template&id=6aac60e2"
import script from "./EmailSender.vue?vue&type=script&lang=ts"
export * from "./EmailSender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports